import { render, staticRenderFns } from "./OESubDetails.vue?vue&type=template&id=34f6da0a&scoped=true&"
import script from "./OESubDetails.vue?vue&type=script&lang=js&"
export * from "./OESubDetails.vue?vue&type=script&lang=js&"
import style0 from "./OESubDetails.vue?vue&type=style&index=0&id=34f6da0a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f6da0a",
  null
  
)

export default component.exports